import React from "react";
import {
  useNavigate
} from "react-router-dom";
import { confirmedDelayMinutes, displayStatus } from "../delay";


  function getMinutesAgo(recordedAtTime) {
    if (typeof recordedAtTime !== "string" || recordedAtTime.trim() === "") {
      return null;
    }
    const recordedTimeMs = Date.parse(recordedAtTime);
    if (!Number.isFinite(recordedTimeMs)) return null;

    // Get the current time
    const now = Date.now();

    // Calculate the difference in milliseconds
    const differenceInMilliseconds = now - recordedTimeMs;

    // Convert milliseconds to minutes and round to the nearest whole number
    const minutesAgo = Math.round(differenceInMilliseconds / (1000 * 60));

    return minutesAgo;
  }


const TrainRow = ({ train }) => {
  const navigate = useNavigate();

  const getStatusClass = () => {
    const delayMinutes = confirmedDelayMinutes(train);
    const isOnTime = displayStatus(train).trim().toLowerCase() === "on time";
    if (isOnTime) return "";
    if (train.holding || delayMinutes > 10) return "redbg";
    if (delayMinutes > 4) return "yellowbg";
    return "";
  };
  
  const minutesAgo = getMinutesAgo(train.recordedAtTime);


  const handleRowClick = () => {
    if (train.liveDataAvailable === false) return;
    navigate(`/${train.trainId}`);
  };
  return (
    <tr onClick={handleRowClick}
      className="clickable-row"
      style={{ cursor: train.liveDataAvailable === false ? "default" : "pointer" }}
    >
      <td>{train.trainId}</td>
      <td className={getStatusClass()}>{displayStatus(train)}{minutesAgo !== null && minutesAgo > 2 && (` (Data last updated ${minutesAgo} minutes ago)`)}</td>
      <td>{train.canceled ? "" : train.location}</td>
    </tr>
  );
};


const TrainRowMobile = ({ train }) => {
  const navigate = useNavigate();
    const handleRowClick = () => {
      if (train.liveDataAvailable === false) return;
      navigate(`/${train.trainId}`);
    };
  // const getStatusClass = () => {
  //   if (train.holding || train.minutesLate > 10) return "red";
  //   if (train.minutesLate > 4) return "yellow";
  //   return "green";
  // };

  const minutesAgo = getMinutesAgo(train.recordedAtTime);

  return (
    <tr onClick={handleRowClick}
      className="clickable-row {getStatusClass()}"
      style={{ cursor: train.liveDataAvailable === false ? "default" : "pointer" }}
    >
      <td>{train.trainId} - {displayStatus(train)}{minutesAgo !== null && minutesAgo > 2 && (` (Data last updated ${minutesAgo} minutes ago)`)} - {train.canceled ? "" : train.location}</td>
    </tr>
  );
};


// Group and export both components
export {
  TrainRow,
  TrainRowMobile
};
